import { Expose } from "class-transformer";
import type { SubscriptionKind } from "../../enums/subscription-kind.enum";
import type { ICmsSubscriptionDto } from "./cms-subscription.dto.interface";

export class CmsSubscriptionDto implements ICmsSubscriptionDto {
  @Expose()
  externalProviderCode!: string;

  @Expose()
  order!: number;

  @Expose()
  kind!: SubscriptionKind;

  @Expose()
  pricingPageDescription!: string;

  @Expose()
  hasAI!: boolean;
}
